// 9fbef606107a605d69c0edbcd8029e5d
const gray = {
  90: '#E5E5E5',
  91: '#f0f0f0',
  92: '#F5F5F5',
  100: '#F4F6F8',
  200: '#e3e3e3',
  300: '#f3f3f3',
  400: '#4a4a4a',
  500: '#d8d8d8',
  600: '#9b9b9b',
  700: '#575757',
  800: '#595959',
  900: '#1a1a1a',
  1000: '#6d7278',
  1050: '#616161',
  1100: '#4a4a4a',
  1200: '#eeeeee',
  1300: '#9c9c9c',
  1400: '#90939b',
  1500: '#c3c3c3',
  1600: '#979797',
  1700: '#333333',
  1800: '#f1f0f0',
  1900: '#4c4848',
  2000: '#e6e6e6',
  2100: '#111111',
  2200: '#c5c5c5',
  2300: '#848484',
  2400: '#c4c4c4',
  2500: '#254f6e',
  2600: '#8f4300',
  2700: '#e3e3e3',
  2800: '#c6c6c6',
  2900: '#F4F6F8',
  3100: '#fafafa',
  3200: '#d9d9d9',
  3300: '#cccccc',
  3400: '#f8f8f8',
  3500: '#b0b0b0',
  3600: '#efefef',
  3700: '#f8f8f8',
  3800: '#cdcdcd',
  3900: '#F7F8F8',
  4000: '#545454',
  5000: '#AAAAAA',
};

export default gray;
